module.exports = __webpack_public_path__ + "static/media/JC.913d99ee.svg";